/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_Post_HeadingInputs */

const ja_news_post_heading = /** @type {(inputs: News_Post_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEWS`)
};

const en_news_post_heading = /** @type {(inputs: News_Post_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEWS`)
};

/**
* | output |
* | --- |
* | "NEWS" |
*
* @param {News_Post_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const news_post_heading = /** @type {((inputs?: News_Post_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_Post_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_news_post_heading(inputs)
	return en_news_post_heading(inputs)
});